import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './ProponiCorrezione.module.css';

/**
 * Bottone flottante «Proponi una correzione» (`#ic-corr-btn` del
 * riferimento): fixed in basso a destra, fondo navy, bordo chiaro sottile,
 * angoli squadrati 2px, z-index 8500 (valore del riferimento, --ic-z-float).
 *
 * Qui è un mailto con pagina corrente nel corpo: niente form fittizio —
 * quando esisterà il flusso contributi dedicato, il bersaglio cambierà.
 */
export function ProponiCorrezione() {
  const { t } = useTranslation();
  const location = useLocation();

  const oggetto = encodeURIComponent(
    t('correction_subject', 'Proposta di correzione — InfoComuni'),
  );
  const corpo = encodeURIComponent(
    `${t('correction_body', 'Pagina:')} ${location.pathname}\n\n`,
  );

  return (
    <a
      href={`mailto:info@infocomuni.it?subject=${oggetto}&body=${corpo}`}
      className={styles.bottone}
    >
      <span aria-hidden="true">✎</span>
      {t('correction_cta', 'Proponi una correzione')}
    </a>
  );
}
